module.exports = __webpack_public_path__ + "img/404_illustration@2x.ad2a324d.png";